import {
  Box,
  styled,
  Typography,
  Button,
  TableCell,
  Table,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  TableBody,
} from '@mui/material';
import { toast } from 'react-toastify';
import useLoadDataList from 'src/hook/useLoadDataList';
import { deleteAssemblyCategory, getAssemblyCategories } from 'src/services/assembly-category';
import { handleApiError } from 'src/utils/api.utils';

export const ListCategories = () => {
  const { data: categories, onRefresh } = useLoadDataList(getAssemblyCategories);

  const handleDelete = async (id: number) => {
    try {
      await deleteAssemblyCategory(id);
      toast.success('Catégorie supprimée avec succès');
      onRefresh();
    } catch (error) {
      handleApiError(error);
    }
  };

  return (
    <Container>
      <Typography variant="h6" gutterBottom>
        Liste des catégories
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '10%' }}>ID</TableCell>
              <TableCell sx={{ width: '50%' }}>Nom</TableCell>
              <TableCell sx={{ width: '20%' }}>Assemblages</TableCell>
              <TableCell sx={{ width: '20%' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {categories?.map((category) => (
              <TableRow key={category.id}>
                <TableCell>{category.id}</TableCell>
                <TableCell>{category.name}</TableCell>
                <TableCell>{category._count?.assemblies ?? 0}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleDelete(category.id)}
                    disabled={(category._count?.assemblies ?? 0) > 0}
                  >
                    Supprimer
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {categories?.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  Aucune catégorie
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  padding: '20px',
});
